module.exports = __webpack_public_path__ + "img/avatar3.2f644d7c.png";